import { ajaxPostJson,ajaxGetJson } from './ajax';
//获取项目所有文件
 export const projectDoc = (params) => {
    return ajaxPostJson(`/project/queryFile`, params,'BaseApi');
}; 
//获取项目文件和搜索
export const getProjectSearch = (params) => {
    return ajaxPostJson(`/file/query_page/all_task`, params,'BaseApi');
};
//获取记忆库文件和搜索
export const getMemorySearch = (params) => {
    return ajaxPostJson(`/memory/getMemoryByProject`, params,'BaseApi');
};
//重新生成报告
export const projecRegenerating = (params) => {
    return ajaxPostJson(`/fileTask/countTransFileReportItem`, params,'BaseApi');
};
//获取统计记录
export const getStatistical = (params) => {
    return ajaxPostJson(`/fileTask/getFileReport`, params,'BaseApi');
};
//统计记录获取列表
export const getFormList = (params) => {
    return ajaxPostJson(`/fileTask/getTransFileReportItem`, params,'BaseApi');
};
//总计列表
export const getAllForm = (params) => {
    return ajaxPostJson(`/fileTask/getTransFileReportCount`, params,'BaseApi');
};
//下载报告
export const downloadReport = (params) => {
    return ajaxPostJson(`/project/exportaAnalysisReport`, params,'BaseApi');
};
// 下载统计报告
export const recordExportaAnalysisReport = (params) => {
  return ajaxPostJson(`/project/recordExportaAnalysisReport`, params,'BaseApi');
};

export const downStatisticsFile = (params) => {
    return ajaxGetJson(`/common/downloadFile?fileName=${params.name}&filePath=${params.path}`);
};